var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"padding":"20px 0 20px 0","background-color":"#2D2D2D"}},[_c('el-col',{staticStyle:{"display":"flex","justify-content":"left","align-items":"center"},attrs:{"span":24}},[_c('span',{staticClass:"search-text",staticStyle:{"z-index":"11"}},[_vm._v("Craig, welcome back!")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12095cd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/welcomeAgent.vue
// module id = null
// module chunks = 